interface HandleInnerHtmlOptions {
	preserveNbsp?: boolean;
}

export const handlerInnerHtml = (
	html: string,
	options?: HandleInnerHtmlOptions,
): string => {
	if (!html) return html;

	const decodedHtml = html
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&#8216;/g, "‘")
		.replace(/&#8217;/g, "’")
		.replace(/&#8211;/g, "–");

	const normalizedHtml = options?.preserveNbsp ? decodedHtml : decodedHtml.replace(/&nbsp;/g, " ");

	// Preserve visual blank lines emitted by the CMS as whitespace-only paired tags.
	return normalizedHtml.replace(
		/<(?!script\b|style\b|svg\b|math\b)([a-z][\w:-]*)([^>]*)>(?:\s|&nbsp;|\u00a0)*<\/\1>/gi,
		(_match, tagName: string, attributes: string) => `<${tagName}${attributes}>&nbsp;</${tagName}>`,
	);
};
